export { PopUp as default } from "components/popUp/PopUp";
